import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import Modal from "react-bootstrap/Modal";
import drag from "../assets/drag.png";
import { useState } from "react";

function ModalCompo(props) {
  const [fileName, setFileName] = useState("");

  const handleFile = (e) => {
    let modalInput = document.querySelector(".modal-input");
    modalInput.click();
  };

  const handleFileChange = (e) => {
    console.log(e.target.files[0].name);
    setFileName(e.target.files[0].name);
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Website
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="my-2" style={{ fontWeight: "bold" }}>
            Website name
          </label>
          <input
            placeholder="Website name "
            className="add_search business_search mb-3 upper_input"
          />
          <label className="my-2" style={{ fontWeight: "bold" }}>
            Website url
          </label>
          <input
            placeholder="Website url "
            className="add_search business_search my-2 upper_input"
          />

          <label className="my-2" style={{ fontWeight: "bold" }}>
            Upload Website Logo
          </label>
          <input
            onChange={handleFileChange}
            className="d-none modal-input"
            type="file"
          ></input>

          <div
            style={{ cursor: "pointer" }}
            onClick={handleFile}
            className="dashed_div"
          >
            <img src={drag} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="ad_btn mb-2">Add Website</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalCompo;
